import { Separator } from '@/components/ui/separator';
import { Skeleton } from '@/components/ui/skeleton';

export const HeaderSkeleton = () => {
  return (
    <header className="bg-base-100/80 pointer-events-none !text-[14px]">
      <section className="flex flex-col items-center justify-between sm:text-xs 2xl:text-[14px]">
        <div className="pointer-events-auto mx-auto w-full overflow-hidden border-brand-200 bg-brand-100 pl-10">
          <div className="flex w-full justify-between gap-8">
            <div className="container flex justify-between sm:w-[85%] md:w-[85%]">
              {/* First Column */}
              <div className="flex w-4/12 flex-col gap-1 py-4 pr-8">
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">First Name Insured:</span>
                  <span className="block w-7/12 overflow-hidden overflow-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Agency:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Assigned User:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Change Effective Date:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Proration:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
              </div>

              <Separator className="my-4 h-auto" orientation="vertical" />

              {/* Second Column */}
              <div className="flex w-4/12 flex-col gap-1 px-8 py-4">
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Quote Number:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Primary Practice State:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Stage/Status:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Policy Period</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-break-spaces font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Transaction Type</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-break-spaces font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
              </div>

              <Separator className="my-4 h-auto" orientation="vertical" />

              {/* Third Column */}
              <div className="flex w-4/12 flex-col gap-1 px-8 py-4">
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Policy Number:</span>
                  <span className="flex w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Transaction ID:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Written Amount:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Billed Amount:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
                <div className="flex gap-4 text-sm">
                  <span className="block w-5/12">Annualized Amount:</span>
                  <span className="block w-7/12 overflow-hidden text-ellipsis whitespace-nowrap font-bold">
                    <Skeleton className="h-4 w-full bg-gray-200" />
                  </span>
                </div>
              </div>
            </div>

            {/* Actions Column */}
            <div className="flex w-2/12 justify-end">
              <Separator className="my-4 h-auto" orientation="vertical" />
              <div className="m-4 flex h-auto w-8/12 max-w-[100px] items-center justify-center">
                <Skeleton className="h-8 w-8 rounded-full bg-gray-200" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </header>
  );
};
